import styled from "styled-components";

const TextContent = styled.div`
  max-width: 100%;
  width: 42rem;
`;

export default TextContent;
